! function(module) {
    //>>excludeStart("requireTmpl", pragmas.requireTmpl);
    if (window.define) {
        define('hotels/masterJsonExt',['common/masterJson'], module)
    } else
        //>>excludeEnd("requireTmpl");
        module()

}(function() {

    return $.extend(CT.masterJson, {
        getGroupedHotels: function() {
            return this.get().htGrouped
        },

        setGroupedHotels: function(json) {
            var /* Array*/ hotels = json || this.get().ht
            var /* Hash */ groupedHt = _.groupBy(hotels, function(hotel) {
                return hotel.id
            });
            return CT.masterJson.get().htGrouped = groupedHt;
        },
        updateGroupedHotels: function(json) {
            var /* Array*/ hotels = json || this.get().ht
            var /*Hash*/ tmpGroupedObj = {}
            var /* Hash */ groupedHt = _.groupBy(hotels, function(hotel) {
                return hotel.id
            });
            tmpGroupedObj = $.extend(CT.masterJson.get().htGrouped, groupedHt)
            return CT.masterJson.get().htGrouped = tmpGroupedObj;
        },
        setHotel: function( /* Object */ hotel) {
            this.getGroupedHotels()[hotel.id] = [hotel]
            return hotel
        },
        removeHotel: function(hotelId, hotelsJson) {
			hotelsJson = hotelsJson || this.get()
            var /* Array*/ hotels = hotelsJson.ht
            hotelsJson.ht = _.filter(hotels, function(hotel) {
                return hotel.id != hotelId
			});
            return hotelsJson;
        },
        getHotel: function(id) {
            if (this.getGroupedHotels()[id] != undefined) {
                return this.getGroupedHotels()[id][0]
            } else {
                return undefined;
            }

        },
        setShortlistedHotelCount: function(num) {
            this.slHotelCount = num || 0;
        },
        getShortListedHotelCount: function() {
            return this.slHotelCount || 0;
        },
        setShortListEnabled: function(isEnabled) {
            this.slEnabled = isEnabled || false;
        },
        isShortListEnabled: function() {
            return this.slEnabled;
        },
        setShortlistId: function(id) {
            this.slid = id;
        },
        getShortlistId: function(id) {
            return this.slid;
        }
    })

});
